// extracted by mini-css-extract-plugin
export default {"refineContainer":"CustomToggleRefinement_refineContainer__xMdph","span":"CustomToggleRefinement_span__nkkwU","selected":"CustomToggleRefinement_selected__49r7w"};